import ChartDesigner from 'scoreboard/charts/model/chart-designer'
function isPolarChart (something) {
	if (something instanceof ChartDesigner) {
		return !!something.features
			.filter(f => f.get('type') === 'serie')
			.map(s => s.get('plotType'))
			.find(it => it === 'polar')
	}

	return !!something.series.find(isPolarSeries)
}

function isPolarSeries (s) {
	return s.properties.get('plotType') === 'polar'
}

export const chart = isPolarChart
export const series = isPolarSeries
